// Libraries
var React = require("react");

// Components
var GenericModal = require('../GenericModal/GenericModal');
var GridGalleryCarousel = require('./GridGalleryCarousel');
var GenericImage = require('../GenericImage/GenericImage');
var OneHotspurButton = require('../OneHotspurButton/OneHotspurButton');
var Icon = require('../../common/Icon/Icon.js');

// Styles
require("./GridGallery.scss");

class GridGalleryModule extends React.Component { 
  constructor(props) {
    super(props);
    this.state = {
      galleryOpen: false,
      initialSlide: 0
    };
  }

  handleOpenGallery(slideIndex) {
    this.setState({
      initialSlide: slideIndex,
      galleryOpen: true
    });
  }

  handleCloseGallery() {
    this.setState({
      galleryOpen: false
    });
  }

  renderOnPageGallery() {
    if(!this.props.data || !this.props.data.slides.length) {
      return null;
    }

    const slides = this.props.data.slides.slice(0, 5).map((item, index) => {
      return (
        <button type="button" className="c-grid-gallery__item" onClick={this.handleOpenGallery.bind(this, index)} key={index}>
          <GenericImage loading="lazy" image={item.image} class="c-grid-gallery__image" alt={`Open ${item.image.altText ? item.image.altText : 'image'} in gallery`} />
          <Icon className="c-grid-gallery__enlarge" name="enlarge" width={39} height={39} />
        </button>
      );
    });

    return slides;
  }

  render() {
    const additionalSectionClass = this.props.data.isOneHotspur ? ' c-section--one-hotspur c-section--one-hotspur-texture-one' : this.props.data.isPremium ? ' c-section--premium' : '';
    const additionalGridGalleryClass = this.props.data.isOneHotspur ? ' c-grid-gallery--one-hotspur' : this.props.data.isPremium ? ' c-grid-gallery--premium' : '';
    return (
        <div className={`c-section c-section--gutter${additionalSectionClass}`} id={this.props.data.id}>
          <div className={`c-grid-gallery${additionalGridGalleryClass}`} id={this.props.data.id || null}>
              <div className="c-section__inner">
                <h2 className="c-grid-gallery__title">{this.props.data.title}</h2>
                <div className="c-grid-gallery__grid">
                    {this.renderOnPageGallery()}
                </div>
                {(this.props.data.link.url && this.props.data.link.caption) &&
                  <p className="c-grid-gallery__action">
                    {this.props.data.isOneHotspur &&
                      <OneHotspurButton alt="false" text={this.props.data.link.caption} href={this.props.data.link.url} />
                    }
                    {!this.props.data.isOneHotspur &&
                      <a href={this.props.data.link.url} className={`c-button ${this.props.data.isPremium ? "c-button--premium" : ""}`}>{this.props.data.link.caption}</a>
                    }
                  </p>
                }
            </div>
          </div>
          {this.state.galleryOpen ?
            <GenericModal isOpen={this.state.galleryOpen} onCancel={this.handleCloseGallery.bind(this)} isPremium={this.props.data.isPremium} closeAccessibilityText="gallery popup">
              <GridGalleryCarousel {...this.props} initialSlide={this.state.initialSlide} />
            </GenericModal>
          : null}
        </div>
    );
  }
}

module.exports = GridGalleryModule;



// WEBPACK FOOTER //
// ./src/components/GridGallery/GridGallery.js